import { Component, NgModule, enableProdMode, OnInit, ViewChild, Input } from '@angular/core';
import { EnrolmentFormService, CourseProduct, PostExamFormStudent, PreExamFormStudent, PreStudentEnrolmentSubjectList, SubjectDetail } from './../../services/enrolment-form.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Tab, AdmissionService, directadmission, UsertDetailsStatus } from "../../services/admission.service";
import { HelperService } from '../../../shared/services/helper.service';
import { Configuration } from '../../../app.constants';
import {
  DxSelectBoxModule,
  DxTextAreaModule,
  DxDateBoxModule,
  DxFormModule
} from 'devextreme-angular';
import { formatDate } from '@angular/common';
import { DxFormComponent } from 'devextreme-angular';
import { CetadmissionService, CETadmission } from './../../services/cetadmission.service';
import { CourseselectionService, EntPreStudentCollegeList, PreStudentOtherInfo, EntPreStudentCourseCheckAlreadyPresent, ScheuldeData } from "../../services/courseselection.service";
import { PersonalinformationService, EnrolmentSubject, EnrolmentSubjectMain, personalinformation2, personalinformation, Occupations } from '../../services/personalinformation.service';

@Component({
  selector: 'enrolment-form',
  templateUrl: './enrolment-form.component.html',
  styleUrls: ['./enrolment-form.component.scss'],
  providers: [EnrolmentFormService]
})
export class EnrolmentFormComponent implements OnInit {
  @ViewChild(DxFormComponent) myform: DxFormComponent;

  documentId: number;
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;
  errorMessage: string[] = new Array();
  preExamFormStudent: PreExamFormStudent;
  courseProducts: CourseProduct[];
  dataSource: any;
  StudentEnrolmentID: number = 0;
  DocumentsList: any;
  showButtons: boolean = true;
  freshflag: string;
  subjectflag: string;
  obj: any;
  LanguageLabel: any;
  GroupList: any;
  loadIndicatorVisible: boolean = false;
  popupVisible3 = false;
  public RemoveFileData: any;
  public flag: any;
  fileDocUpload1: any;
  postExamFormStudent: PostExamFormStudent = {
    TotalFeeAmount: 0,
    LateFeeAmount: 0,
    UpdatedLoginID: 0,
    StudentExamID: 0,
    CoursePartID: 0,
    BranchID: 0,
    StudentID: 0,
    CourseID: 0,
    subjectDetail: [],
    PreStudentEnrolmentSubjectList: [],
    ExamApplicationDate: null,
    ImprovementFlag: null,
    RedegreeFlag: null,
    PhysicalDisabilityID: 0,
    SeatNo: 0,
    ReservationCategoryID: 0,
    StudentType: null,
    FreshRepeaterFlag: null,
    CreatedLoginID: 0,
    AcademicInstanceID: 0,
    CollegeID: 0,
    EnrolmentDate: null,
    EntryFlag: null,
    FeeAmount: 0,
    TotalAmount: 0,
    CollegeAmount: 0,
    UniversityAmount: 0,
    TotalFeesAmount: 0,
    DDNumber: null,
    DDDate: null,
    ExamInstanceID: 0,
    StudentEnrolmentID: 0,
    PaymentType: null,
    FeesID: 0,
    ReceiptNo: null,
    ReceiptDate: null,
    PrevExam1Obtain: 0,
    PrevExam1OutOff: 0,
    PrevExam2Obtain: 0,
    PrevExam2OutOff: 0,
    PrevExam1SpecObtain: 0,
    PrevExam1SpecOutOff: 0,
    PrevExam2SpecObtain: 0,
    PrevExam2SpecOutOff: 0,
    PrevExamMarksSheet: null,
    PrevExamMarksSheet2: null,
    PrevAdmReceipt: null,

  };
  private sub: any;
  isdisable: boolean = true;
  isValid: boolean;
  RequestID: number;
  Fees: number;
  branchdatasource1: any;
  ScheduleList: any;
  PhyDisData: any;
  ReDegreeData: any = [
    {
      "ReDegreeName": "Yes",
      "RedegreeFlag": "Y"
    },
    {
      "ReDegreeName": "No",
      "RedegreeFlag": "N"
    }
  ];
  ImprovementFlagData: any = [
    {
      "ImprovementFlagName": "Yes",
      "ImprovementFlag": "Y"
    },
    {
      "ImprovementFlagName": "No",
      "ImprovementFlag": "N"
    }
  ];
  StudentTypeData: any = [
    {
      "StudentType": "Regular",
      "StudentTypeID": "R"
    },
    {
      "StudentType": "Distance",
      "StudentTypeID": "D"
    }
  ];
  payMode = [
    "Receipt",
    "DD",
    "Online",

  ];
  PreExamFormStudentData: any;
  PreExamFormStudentData1: PreExamFormStudent;
  PreExamFormStudentData2: any;
  PreExamFormStudentData3: any;
  printdis: boolean = true;
  ExamFormPrintData: any;
  ExamFormPrint: any;
  StudentEnrollmentList: any;
  ISApprove: boolean;
  Savedisabled: boolean;
  paysource: any;
  paymentdis: boolean = true;
  paymentmsg: string = "";
  now: Date = new Date();
  payModeID: number;
  isExpired: boolean;
  isDD: boolean = true;
  SaveClick: boolean = false;
  count: number = 0;
  printrecdis: boolean = true;

  GroupListChild: any;
  MainSyllabusGroupID: number;
  GroupMaxItemMain: number;
  GroupMinimumItemMain: number;
  GroupMaxCredits: number;
  GroupMinCredits: number;
  EnrolmentSubjectdata: any;
  BranchID: number = 0;
  branchdisable: boolean = false;
  prvmarkrequired: boolean = false;
  EnrolementBranchSelectionList: any;
  data: any;
  branchislection: boolean = false;

  constructor(private EnrolmentFormService: EnrolmentFormService, private cetService: CetadmissionService,
    private route: ActivatedRoute, private CourseselectionService: CourseselectionService, private AdmissionService: AdmissionService,
    private PersonalinformationService: PersonalinformationService, private router: Router, private helperService: HelperService, public configuration: Configuration) {
  }
  checkCompulsoryOrOptionalSubject() {
    debugger;
    if (this.PreExamFormStudentData1 && this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length > 0) {
      for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
        var subjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i];
        subjectList.rowId = i + 1;
        /*  if (subjectList.EnrolmentSubjectID > 0) {
            subjectList.IsChecked = true;
            } */

        if ((subjectList.Appear == "R") || (subjectList.Appear == "C")) {
          subjectList.IsChecked = true;
          subjectList.IsDisabled = true;
          subjectList.GroupCompulsaryFlag1 = "Compulsory";
        }
        else if (subjectList.Appear == "O") {
          subjectList.IsChecked = false;
          subjectList.GroupCompulsaryFlag1 = "Optional";
        }
        if ((subjectList.Appear == "R") || (subjectList.Appear == "C")) {
          subjectList.IsChecked = true;
          subjectList.IsDisabled = true;
          subjectList.GroupCompulsaryFlag1 = "Compulsory";
        }
        if (subjectList.StudentEnrolmentID != 0) {
          subjectList.IsChecked = true;
        }
        if (this.PreExamFormStudentData1.ApproveFlag == "Y") {
          subjectList.IsDisabled = true;
        }
      }

      for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
        this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i].SyllabusGroupName1 = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i].SyllabusGroupName + " ( You can select only " + this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i].GroupMaxItem + " course of this group)";
        if (this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i].IsChecked == true) {
          this.count = this.count + 1;
        }
      }
    }
  }

  UpdateEvent(e) {
    if (e.newData.IsChecked == true) {
      this.count = this.count + 1;
    }
    if (e.newData.IsChecked == false) {
      if (this.count > 0) {
        this.count = this.count - 1;
      }
    }
  }

  checkMinMaxValidation() {
    var SyllabusGroupID = 0;
    var returnvalue = true;
    this.GroupList = [];
    for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
      var subjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i];
      if (subjectList.IsChecked) {
        if ((subjectList.Appear == "R") || (subjectList.Appear == "C")) {
        } else {
          if (SyllabusGroupID != subjectList.SyllabusGroupID) {
            this.obj = [];
            this.obj.SyllabusGroupID = subjectList.SyllabusGroupID;
            this.obj.GroupMaxItem = subjectList.GroupMaxItem;
            this.obj.GroupMinimumItem = subjectList.GroupMinimumItem;
            this.obj.SyllabusGroupName = subjectList.SyllabusGroupName;
            this.obj.SelectedSubCnt = 0;
            this.GroupList.push(this.obj);
            SyllabusGroupID = subjectList.SyllabusGroupID;
          }
        }
      }
    }
    for (var j = 0; j < this.GroupList.length; j++) {
      var SubjectID = 0;
      for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
        var subjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i];
        if (subjectList.IsChecked) {
          if (subjectList.SyllabusGroupID == this.GroupList[j].SyllabusGroupID) {
            if (subjectList.SubjectID != SubjectID) {
              this.GroupList[j].SelectedSubCnt = this.GroupList[j].SelectedSubCnt + 1;
            }
            SubjectID = subjectList.SubjectID;
          }
        }
      }
    }
    for (var j = 0; j < this.GroupList.length; j++) {
      if (this.GroupList[j].SelectedSubCnt > this.GroupList[j].GroupMaxItem) {
        this.helperService.showWarningMessage("Subjects of " + this.GroupList[j].SyllabusGroupName + " are not more than " + this.GroupList[j].GroupMaxItem + "");
        returnvalue = false;
        return false;
      }
      if (this.GroupList[j].SelectedSubCnt < this.GroupList[j].GroupMinimumItem) {
        this.helperService.showWarningMessage("Subjects of " + this.GroupList[j].SyllabusGroupName + "  are not less than " + this.GroupList[j].GroupMinimumItem + "");
        returnvalue = false;
        return false;
      }
    }


    this.GroupListChild = [];

    for (var j = 0; j < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; j++) {
      var subjectListSubject = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[j];
      if (this.MainSyllabusGroupID == subjectListSubject.MainSyllabusGroupID) {
        var SyllabusGroupID = 0;
        for (var k = 0; k < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; k++) {
          var NewsubjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[k];
          if (NewsubjectList.IsChecked && NewsubjectList.MainSyllabusGroupID == this.MainSyllabusGroupID) {
            var cntprse = false;
            for (var s = 0; s < this.GroupListChild.length; s++) {
              if (this.GroupListChild[s].SyllabusGroupID == NewsubjectList.SyllabusGroupID) {
                cntprse = true;
              }
            }
            if (cntprse == false && NewsubjectList.Appear != "C") {
              this.obj = [];
              this.obj.SyllabusGroupID = NewsubjectList.SyllabusGroupID;
              this.obj.GroupMaxItem = NewsubjectList.GroupMaxItem;
              this.obj.GroupMinimumItem = NewsubjectList.GroupMinimumItem;
              this.obj.SyllabusGroupName = NewsubjectList.SyllabusGroupName;
              this.obj.SelectedSubCnt = 0;
              this.obj.GroupMaxItemMain = this.GroupMaxItemMain;
              this.obj.GroupMinimumItemMain = this.GroupMinimumItemMain;
              this.GroupListChild.push(this.obj);
              SyllabusGroupID = subjectList.SyllabusGroupID;
            }
          }
        }
      }
    }


    for (var j = 0; j < this.GroupListChild.length; j++) {
      var SubjectID = 0;
      for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
        var subjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i];
        if (subjectList.IsChecked) {
          if (subjectList.SyllabusGroupID == this.GroupListChild[j].SyllabusGroupID) {
            if (subjectList.SubjectID != SubjectID) {
              this.GroupListChild[j].SelectedSubCnt = this.GroupListChild[j].SelectedSubCnt + 1;
            }
            SubjectID = subjectList.SubjectID;
          }
        }
      }
    }
    if (this.MainSyllabusGroupID > 0) {
      if (this.GroupListChild.length == 0) {
        this.helperService.showWarningMessage("Please check the Syllabus");
        returnvalue = false;
        return false;
      }
    }
    for (var j = 0; j < this.GroupListChild.length; j++) {
      if (this.GroupListChild[j].GroupMaxItemMain > j + 1 && this.GroupListChild[j].GroupMinimumItemMain > j + 1) {
      } else {
        if (this.GroupListChild[j].SelectedSubCnt > this.GroupListChild[j].GroupMaxItem) {
          this.helperService.showWarningMessage("Subjects of " + this.GroupListChild[j].SyllabusGroupName + " are not more than " + this.GroupListChild[j].GroupMaxItem + "");
          returnvalue = false;
          return false;
        }
        if (this.GroupListChild[j].SelectedSubCnt < this.GroupListChild[j].GroupMinimumItem) {
          this.helperService.showWarningMessage("Subjects of " + this.GroupListChild[j].SyllabusGroupName + "  are not less than " + this.GroupListChild[j].GroupMinimumItem + "");
          returnvalue = false;
          return false;
        }
      }
    }


    var SubjectIDSelected = 0;
    var SubjectID = 0;
    for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
      var subjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i];
      if (subjectList.IsChecked) {
        if (SubjectID != subjectList.SubjectID) {
          SubjectIDSelected = SubjectIDSelected + 1;
        }
      }
    }
    if (SubjectIDSelected > this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[0].MaxNoOfSubjects) {
      this.helperService.showWarningMessage("Subjects are not more than " + this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[0].MaxNoOfSubjects + "");
      returnvalue = false;
      return false;
    }
    if (SubjectIDSelected < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[0].MinNoOfSubjects) {
      this.helperService.showWarningMessage("Subjects are not less than " + this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[0].MinNoOfSubjects + "");
      returnvalue = false;
      return false;
    }
    return returnvalue;
  }
  saveRecord() {

    if (this.EnrolementBranchSelectionList.length > 0) {
      if (this.BranchID == null || this.BranchID == undefined || this.BranchID == 0) {
        this.helperService.showWarningMessage("Select Specialization");
        return;
      } else {
        this.PreExamFormStudentData1.BranchID = this.BranchID;
      }
    }
    debugger;
    if (this.PreExamFormStudentData1.PrevExamMarksSheet == undefined) {
      this.PreExamFormStudentData1.PrevExamMarksSheet = "";
    }
    if (this.PreExamFormStudentData1.PrevExamMarksSheet2 == undefined) {
      this.PreExamFormStudentData1.PrevExamMarksSheet2 = "";
    }
    if (this.PreExamFormStudentData1.PrevAdmReceipt == undefined) {
      this.PreExamFormStudentData1.PrevAdmReceipt = "";
    }
    /* if(this.PreExamFormStudentData1.PrevExamMarksSheet.length == 0){
      if(this.configuration.EnrolmentFile == undefined || this.configuration.EnrolmentFile == null){
      this.helperService.showWarningMessage("Upload Last Year/Sem MarkSheet 1");
      return;
      }
    } */
    /* if(this.PreExamFormStudentData1.PrevExamMarksSheet2.length == 0){
     if(this.configuration.EnrolmentFile2 == undefined || this.configuration.EnrolmentFile2 == null){
       this.helperService.showWarningMessage("Upload Last Year/Sem MarkSheet 2");
       return;
     }
    } */

    /* if(this.PreExamFormStudentData1.PrevAdmReceipt.length == 0){
      if(this.configuration.EnrolmentFile3 == undefined || this.configuration.EnrolmentFile3 == null){
        this.helperService.showWarningMessage("Upload Payment Receipt.");
        return;
      }
    } */

    //// SKIP DISPLAY SUBJECT ON SUBJECTCOMPFLAG CHANGES ON 06-06-2023 SUGGESTED BY PRASAD SIR
    //copied from PVG to mahaveer
    //if(this.PreExamFormStudentData.SubjectCompFlag == "Y") //added thi line from PVG
    //  {
    if (this.PreExamFormStudentData.SubjectShowFlag == "Y") {
      if (this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList == null || this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length == 0 || this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList == undefined) {
        this.helperService.showWarningMessage("No any Subject selected");
        return;
      }
      if (this.checkMinMaxValidation() == false) {
        return;
      }
    }
    // }


    this.Savedisabled = true;
    /*   this.PreExamFormStudentData1.PaymentType="O";
      if(this.PreExamFormStudentData1.PaymentType==null || this.PreExamFormStudentData1.PaymentType==undefined || this.PreExamFormStudentData1.PaymentType==""){
        this.helperService.showWarningMessage("Select Payment Type");
        return false;
      } */
    /*  if(this.PreExamFormStudentData1.PaymentType=="R"){
       var result=1;
           if(this.PreExamFormStudentData1.DDDate==null || this.PreExamFormStudentData1.DDDate==undefined || this.PreExamFormStudentData1.DDDate==""){
             this.helperService.showWarningMessage("Enter Date of DD/Receipt");
             return false;
             result=0;
           }
           else{
             this.postExamFormStudent.ReceiptDate=this.PreExamFormStudentData1.DDDate;
           }
           if(this.PreExamFormStudentData1.DDNumber==null || this.PreExamFormStudentData1.DDNumber==undefined || this.PreExamFormStudentData1.DDNumber==""){
             this.helperService.showWarningMessage("Enter DD/Rec.No");
             return false;
             result=0;
           }
           else{
             this.postExamFormStudent.ReceiptNo=this.PreExamFormStudentData1.DDNumber;
           }
           if(result=1 ){ this.PreExamFormStudentData1.PaymentType="C";}
       this.postExamFormStudent.DDDate=formatDate(new Date(), 'dd/MMM/yyyy', 'en');
       this.postExamFormStudent.DDNumber='';
     }
     if(this.PreExamFormStudentData1.PaymentType=="D"){ 
     var result=1;
             if(this.PreExamFormStudentData1.DDDate==null || this.PreExamFormStudentData1.DDDate==undefined || this.PreExamFormStudentData1.DDDate==""){
               this.helperService.showWarningMessage("Enter Date of DD/Receipt");
               return false;
               result=0;
             }
             else{
               this.postExamFormStudent.DDDate=formatDate(this.PreExamFormStudentData1.DDDate, 'dd/MMM/yyyy', 'en');
               
             }
             if(this.PreExamFormStudentData1.DDNumber==null || this.PreExamFormStudentData1.DDNumber==undefined || this.PreExamFormStudentData1.DDNumber==""){
               this.helperService.showWarningMessage("Enter DD/Rec.No");
               return false;
               result=0;
             }
             else{
               this.postExamFormStudent.DDNumber=this.PreExamFormStudentData1.DDNumber;
             
             }
             if(result=1 ){ this.PreExamFormStudentData1.PaymentType="C";}
         this.postExamFormStudent.ReceiptDate=formatDate(new Date(), 'dd/MMM/yyyy', 'en');
         this.postExamFormStudent.ReceiptNo='';
         
       }
    if(this.PreExamFormStudentData1.PaymentType=="O"){
         this.postExamFormStudent.DDDate=formatDate(new Date(), 'dd/MMM/yyyy', 'en');
         this.postExamFormStudent.DDNumber='';
         this.postExamFormStudent.ReceiptDate=formatDate(new Date(), 'dd/MMM/yyyy', 'en');
         this.postExamFormStudent.ReceiptNo='';
     } */
    this.postExamFormStudent.ReceiptDate = formatDate(new Date(), 'dd/MMM/yyyy', 'en');
    this.postExamFormStudent.ReceiptNo = '';
    this.postExamFormStudent.DDDate = formatDate(new Date(), 'dd/MMM/yyyy', 'en');
    this.postExamFormStudent.DDNumber = '';

    this.postExamFormStudent.EnrolmentDate = formatDate(new Date(), 'dd/MMM/yyyy', 'en');
    this.postExamFormStudent.FreshRepeaterFlag = this.freshflag;
    this.postExamFormStudent.ImprovementFlag = this.PreExamFormStudentData1.ImprovementFlag;
    this.postExamFormStudent.RedegreeFlag = this.PreExamFormStudentData1.RedegreeFlag;
    this.postExamFormStudent.PhysicalDisabilityID = this.PreExamFormStudentData1.PhysicalDisabilityID;
    this.postExamFormStudent.SeatNo = this.PreExamFormStudentData1.SeatNo;
    this.postExamFormStudent.ReservationCategoryID = this.PreExamFormStudentData1.ReservationCategoryID;
    this.postExamFormStudent.StudentType = this.PreExamFormStudentData1.StudentType;
    this.postExamFormStudent.TotalFeesAmount = this.PreExamFormStudentData1.TotalFeesAmount;
    this.postExamFormStudent.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.postExamFormStudent.StudentExamID = this.PreExamFormStudentData1.StudentExamID;
    this.postExamFormStudent.StudentID = this.configuration.StudentID;
    this.postExamFormStudent.CoursePartID = this.PreExamFormStudentData1.CoursePartID;
    this.postExamFormStudent.BranchID = this.PreExamFormStudentData1.BranchID;
    this.postExamFormStudent.AcademicInstanceID = this.configuration.AcademicInstanceID;
    this.postExamFormStudent.CollegeID = this.PreExamFormStudentData1.CollegeID;
    this.postExamFormStudent.EntryFlag = "E";
    this.postExamFormStudent.TotalAmount = this.PreExamFormStudentData1.TotalAmount;
    this.postExamFormStudent.LateFeeAmount = this.PreExamFormStudentData1.LateFeeAmount;
    this.postExamFormStudent.TotalFeesAmount = this.PreExamFormStudentData1.TotalFeesAmount;
    this.postExamFormStudent.UniversityAmount = this.PreExamFormStudentData1.UniversityAmount;
    this.postExamFormStudent.CollegeAmount = this.PreExamFormStudentData1.CollegeAmount;
    this.postExamFormStudent.FeeAmount = this.PreExamFormStudentData1.TotalFeesAmount;
    this.PreExamFormStudentData1.LateFeeAmount = this.PreExamFormStudentData1.LateFeeAmount;


    if (this.PreExamFormStudentData1.PrevExam1Obtain == null || this.PreExamFormStudentData1.PrevExam1Obtain == undefined || this.PreExamFormStudentData1.PrevExam1Obtain == 0) {
      this.PreExamFormStudentData1.PrevExam1Obtain = 0;
    }

    if (this.PreExamFormStudentData1.PrevExam1OutOff == null || this.PreExamFormStudentData1.PrevExam1OutOff == undefined || this.PreExamFormStudentData1.PrevExam1OutOff == 0) {
      this.PreExamFormStudentData1.PrevExam1OutOff = 0;
    }
    if (this.PreExamFormStudentData1.PrevExam2Obtain == null || this.PreExamFormStudentData1.PrevExam2Obtain == undefined || this.PreExamFormStudentData1.PrevExam2Obtain == 0) {
      this.PreExamFormStudentData1.PrevExam2Obtain = 0;
    }
    if (this.PreExamFormStudentData1.PrevExam2OutOff == null || this.PreExamFormStudentData1.PrevExam2OutOff == undefined || this.PreExamFormStudentData1.PrevExam2OutOff == 0) {
      this.PreExamFormStudentData1.PrevExam2OutOff = 0;
    }

    if (this.PreExamFormStudentData1.PrevExam1SpecObtain == null || this.PreExamFormStudentData1.PrevExam1SpecObtain == undefined || this.PreExamFormStudentData1.PrevExam1SpecObtain == 0) {
      this.PreExamFormStudentData1.PrevExam1SpecObtain = 0;
    }

    if (this.PreExamFormStudentData1.PrevExam1SpecOutOff == null || this.PreExamFormStudentData1.PrevExam1SpecOutOff == undefined || this.PreExamFormStudentData1.PrevExam1SpecOutOff == 0) {
      this.PreExamFormStudentData1.PrevExam1SpecOutOff = 0;
    }

    if (this.PreExamFormStudentData1.PrevExam2SpecObtain == null || this.PreExamFormStudentData1.PrevExam2SpecObtain == undefined || this.PreExamFormStudentData1.PrevExam2SpecObtain == 0) {
      this.PreExamFormStudentData1.PrevExam2SpecObtain = 0;
    }

    if (this.PreExamFormStudentData1.PrevExam2SpecOutOff == null || this.PreExamFormStudentData1.PrevExam2SpecOutOff == undefined || this.PreExamFormStudentData1.PrevExam2SpecOutOff == 0) {
      this.PreExamFormStudentData1.PrevExam2SpecOutOff = 0;
    }

    //do not remove -  CoursePartID (B.Sc.(CBCS) PART III SEM V) set temp. hard coded for previous marks(as per discuss wih Anand sir) 
// SUGGESTED BY ZAPKE SIR ON 10-08-2023  START 
    // if (this.PreExamFormStudentData1.CoursePartID == 4843) {

    //   if (this.PreExamFormStudentData1.PrevExam1Obtain == 0) {
    //     this.helperService.showWarningMessage("Required 3rh Sem Obtained Marks.");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam1OutOff == 0) {
    //     this.helperService.showWarningMessage("Required 3rh Sem Out Off Marks.");
    //     return false;
    //   }
    //   if (this.PreExamFormStudentData1.PrevExam2Obtain == 0) {
    //     this.helperService.showWarningMessage("Required 4th Sem Obtained Marks.");
    //     return false;
    //   }
    //   if (this.PreExamFormStudentData1.PrevExam2OutOff == 0) {
    //     this.helperService.showWarningMessage("Required 4th Sem Out Off Marks.");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam1SpecObtain == 0) {
    //     this.helperService.showWarningMessage("Required Special Subject 3rh Sem Obtained Marks.");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam1SpecOutOff == 0) {
    //     this.helperService.showWarningMessage("Required Special Subject 3rh Sem Out Off Marks.");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam2SpecObtain == 0) {
    //     this.helperService.showWarningMessage("Required Special Subject 4th Sem Obtained Marks.");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam2SpecOutOff == 0) {
    //     this.helperService.showWarningMessage("Required Special Subject 4th Sem Out Off Marks.");
    //     return false;
    //   }

    //   if ((this.PreExamFormStudentData1.PrevExam1Obtain.toString).length > 4) {
    //     this.helperService.showWarningMessage(" 3rh Sem Obtained must be less than 4 digits.");
    //     return false;
    //   }

    //   if ((this.PreExamFormStudentData1.PrevExam1OutOff.toString).length > 4) {
    //     this.helperService.showWarningMessage(" 3rh Sem Out Off must be less than 4 digits.");
    //     return false;
    //   }
    //   if ((this.PreExamFormStudentData1.PrevExam2Obtain.toString).length > 4) {
    //     this.helperService.showWarningMessage(" 4th Sem Obtained must be less than 4 digits.");
    //     return false;
    //   }
    //   if ((this.PreExamFormStudentData1.PrevExam2OutOff.toString).length > 4) {
    //     this.helperService.showWarningMessage(" 4th Sem Out Off must be less than 4 digits.");
    //     return false;
    //   }

    //   if ((this.PreExamFormStudentData1.PrevExam1SpecObtain.toString).length > 4) {
    //     this.helperService.showWarningMessage(" Special Subject 3rh Sem Obtained must be less than 4 digits.");
    //     return false;
    //   }

    //   if ((this.PreExamFormStudentData1.PrevExam1SpecOutOff.toString).length > 4) {
    //     this.helperService.showWarningMessage(" Special Subject 3rh Sem Out Off must be less than 4 digits.");
    //     return false;
    //   }

    //   if ((this.PreExamFormStudentData1.PrevExam2SpecObtain.toString).length > 4) {
    //     this.helperService.showWarningMessage(" Special Subject 4th Sem Obtained must be less than 4 digits.");
    //     return false;
    //   }

    //   if ((this.PreExamFormStudentData1.PrevExam2SpecOutOff.toString).length > 4) {
    //     this.helperService.showWarningMessage(" Special Subject 4th Sem Out Off must be less than 4 digits.");
    //     return false;
    //   }
    //   debugger
    //   if (this.PreExamFormStudentData1.PrevExam1Obtain > this.PreExamFormStudentData1.PrevExam1OutOff) {
    //     this.helperService.showWarningMessage("3rh Sem Obtained Marks Should be less than Out of Marks");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam2Obtain > this.PreExamFormStudentData1.PrevExam2OutOff) {
    //     this.helperService.showWarningMessage("4th Sem Obtained Marks Should be less than Out of Marks");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam1SpecObtain > this.PreExamFormStudentData1.PrevExam1SpecOutOff) {
    //     this.helperService.showWarningMessage("Special Subject 3rd Sem Obtained Marks Should be less than Out of Marks");
    //     return false;
    //   }

    //   if (this.PreExamFormStudentData1.PrevExam2SpecObtain > this.PreExamFormStudentData1.PrevExam2SpecOutOff) {
    //     this.helperService.showWarningMessage("Special Subject 4th Sem Obtained Marks Should be less than Out of Marks");
    //     return false;
    //   }


    //   this.postExamFormStudent.PrevExam1Obtain = this.PreExamFormStudentData1.PrevExam1Obtain;
    //   this.postExamFormStudent.PrevExam1OutOff = this.PreExamFormStudentData1.PrevExam1OutOff;
    //   this.postExamFormStudent.PrevExam2Obtain = this.PreExamFormStudentData1.PrevExam2Obtain;
    //   this.postExamFormStudent.PrevExam2OutOff = this.PreExamFormStudentData1.PrevExam2OutOff;
    //   this.postExamFormStudent.PrevExam1SpecObtain = this.PreExamFormStudentData1.PrevExam1SpecObtain;
    //   this.postExamFormStudent.PrevExam1SpecOutOff = this.PreExamFormStudentData1.PrevExam1SpecOutOff;
    //   this.postExamFormStudent.PrevExam2SpecObtain = this.PreExamFormStudentData1.PrevExam2SpecObtain;
    //   this.postExamFormStudent.PrevExam2SpecOutOff = this.PreExamFormStudentData1.PrevExam2SpecOutOff;
    // }

// SUGGESTED BY ZAPKE SIR ON 10-08-2023  END 


    this.postExamFormStudent.subjectDetail = [];
    this.postExamFormStudent.PreStudentEnrolmentSubjectList = [];
    for (var i = 0; i < this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList.length; i++) {
      var subjectList = this.PreExamFormStudentData1.PreStudentEnrolmentSubjectList[i];
      if (subjectList.FreshRepeaterFlag == true) {
        this.freshflag = "Y"
      }
      if (subjectList.FreshRepeaterFlag == false) {
        this.freshflag = "N"
      }
      if (subjectList.SubjectStatusFlag == true) {
        this.subjectflag = "Y"
      }
      if (subjectList.SubjectStatusFlag == false) {
        this.subjectflag = "N"
      }
      if (subjectList.IsChecked) {
        var subjectDetail = {
          EnrolmentSubjectID: subjectList.EnrolmentSubjectID,
          StudentEnrolmentID: subjectList.StudentEnrolmentID,
          CoursePartDescription: subjectList.CoursePartDescription,
          SubjectUniversityCode: subjectList.SubjectUniversityCode,
          SubjectName: subjectList.SubjectName,
          MaxNoOfSubjects: subjectList.MaxNoOfSubjects,
          SyllabusGroupName: subjectList.SyllabusGroupName,
          SyllabusGroupID: subjectList.SyllabusGroupID,
          GroupMaxItem: subjectList.GroupMaxItem,
          GroupMinimumItem: subjectList.GroupMinimumItem,
          GroupOrSubjectFlag: subjectList.GroupOrSubjectFlag,
          GroupCompulsaryFlag: subjectList.GroupCompulsaryFlag,
          SubjectCompulsoryOptionalFlag: subjectList.Appear,
          StudentExamID: subjectList.StudentExamID,
          CoursePartID: subjectList.CoursePartID,
          BranchID: subjectList.BranchID,
          SyllabusID: subjectList.SyllabusID,
          SubjectID: subjectList.SubjectID,
          CategoryID: subjectList.CategoryID,
          PaperID: subjectList.PaperID,
          SectionID: subjectList.SectionID,
          ExamCentreCollegeID: subjectList.ExamCentreCollegeID,
          FreshRepeaterFlag: subjectList.Appear,
          SubjectStatusFlag: this.subjectflag,
          SubjectStatus: subjectList.Appear,
          CreatedLoginID: this.configuration.CreatedLoginID,
          UpdatedLoginID: this.configuration.UpdatedLoginID
        };
        this.postExamFormStudent.subjectDetail.push(subjectDetail);

      }
    }
    this.postExamFormStudent.CreatedLoginID = this.configuration.CreatedLoginID;
    this.postExamFormStudent.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.postExamFormStudent.ExamInstanceID = this.configuration.ExamInstanceID;
    this.postExamFormStudent.StudentEnrolmentID = this.PreExamFormStudentData1.StudentEnrolmentID;
    this.postExamFormStudent.PreStudentEnrolmentSubjectList = this.postExamFormStudent.subjectDetail;
    this.postExamFormStudent.CourseID = this.PreExamFormStudentData1.CourseID;
    if ((this.PreExamFormStudentData1.StudentEnrolmentID == undefined)) { this.PreExamFormStudentData1.StudentEnrolmentID = 0; }
    if (this.PreExamFormStudentData1.StudentEnrolmentID == 0) {
      debugger
      this.EnrolmentFormService.save(this.postExamFormStudent)
        .subscribe(value => {
          this.helperService.showSuccessMessage("Enrolment Form Saved.");
          this.SaveClick = true;

          this.EnrolmentFormService.GetExamFormPrint(this.configuration.StudentID, this.PreExamFormStudentData1.CourseID, this.PreExamFormStudentData1.BranchID,this.PreExamFormStudentData1.CoursePartID, this.configuration.CollegeID, this.configuration.AcademicInstanceID) // 
            .subscribe((data: PreExamFormStudent) => this.ExamFormPrintData = data,
              error => {
                alert(error);
              },
              () => {
                this.ExamFormPrint = this.ExamFormPrintData.Message;
                this.printdis = false;
                this.uploadFile();
              });
        },
          err => {
            this.helperService.showSuccessMessage("Not Saved.");
            this.Savedisabled = false;
          },
          () => {
          });
    }
    else {
      this.EnrolmentFormService.update(this.postExamFormStudent)
        .subscribe(value => {debugger
          this.SaveClick = true;
          this.helperService.showSuccessMessage("Enrolment Form Saved.");
          //this.router.navigate(['/dashboard']);
          this.EnrolmentFormService.GetExamFormPrint(this.configuration.StudentID, this.PreExamFormStudentData1.CourseID, this.PreExamFormStudentData1.BranchID,this.PreExamFormStudentData1.CoursePartID, this.configuration.CollegeID,this.configuration.AcademicInstanceID) // ,this.configuration.AcademicInstanceID,this.PreExamFormStudentData1.CoursePartID,
            .subscribe((data: PreExamFormStudent) => this.ExamFormPrintData = data,
              error => {
                alert(error);
              },
              () => {debugger
                this.ExamFormPrint = this.ExamFormPrintData.Message;
                this.printdis = false;
                this.uploadFile();
              });
        },
          err => {
            this.helperService.showSuccessMessage("Not Saved.");
            this.Savedisabled = false;
          },
          () => {
          });
    }

  }
  uploadFile() {
    debugger
    if (this.PreExamFormStudentData1.StudentEnrolmentID == undefined && this.PreExamFormStudentData1.StudentEnrolmentID == null) {
      this.PreExamFormStudentData1.StudentEnrolmentID = 0;
    }
    if (this.PreExamFormStudentData1.StudentEnrolmentID == 0) {
      this.EnrolmentFormService.GetStudentEnrollmentListForPortal(this.configuration.StudentID, this.PreExamFormStudentData.CoursePartID, this.configuration.AcademicInstanceID)
        .subscribe((data: PreExamFormStudent) => this.StudentEnrollmentList = data,
          error => {
            alert(error);
          },
          () => {
            if (this.StudentEnrollmentList.length > 0) {
              debugger

              if (this.configuration.EnrolmentFile != undefined && this.configuration.EnrolmentFile != null) {
                this.EnrolmentFormService.uploadEnrolmentFile(this.configuration.EnrolmentFile, this.configuration.StudentID, this.StudentEnrollmentList[0].StudentEnrolmentID, 1).subscribe(
                  data => {
                  },
                  err => {
                    debugger;
                  },
                  () => {
                  })
              }
              if (this.configuration.EnrolmentFile2 != undefined && this.configuration.EnrolmentFile2 != null) {
                this.EnrolmentFormService.uploadEnrolmentFile(this.configuration.EnrolmentFile2, this.configuration.StudentID, this.StudentEnrollmentList[0].StudentEnrolmentID, 2).subscribe(
                  data => {
                  },
                  err => {
                    debugger;
                  },
                  () => {
                  })
              }

              if (this.configuration.EnrolmentFile3 != undefined && this.configuration.EnrolmentFile3 != null) {
                this.EnrolmentFormService.uploadEnrolmentFile(this.configuration.EnrolmentFile3, this.configuration.StudentID, this.StudentEnrollmentList[0].StudentEnrolmentID, 3).subscribe(
                  data => {
                  },
                  err => {
                    debugger;
                  },
                  () => {
                  })
              }
            }
          });
    }
    else {


      if (this.configuration.EnrolmentFile != undefined && this.configuration.EnrolmentFile != null) {
        this.EnrolmentFormService.uploadEnrolmentFile(this.configuration.EnrolmentFile, this.configuration.StudentID, this.PreExamFormStudentData1.StudentEnrolmentID, 1).subscribe(
          data => {
          },
          err => {
            debugger;
          },
          () => {
          })
      }
      if (this.configuration.EnrolmentFile2 != undefined && this.configuration.EnrolmentFile2 != null) {
        this.EnrolmentFormService.uploadEnrolmentFile(this.configuration.EnrolmentFile2, this.configuration.StudentID, this.PreExamFormStudentData1.StudentEnrolmentID, 2).subscribe(
          data => {
          },
          err => {
            debugger;
          },
          () => {
          })
      }

      if (this.configuration.EnrolmentFile3 != undefined && this.configuration.EnrolmentFile3 != null) {
        this.EnrolmentFormService.uploadEnrolmentFile(this.configuration.EnrolmentFile3, this.configuration.StudentID, this.PreExamFormStudentData1.StudentEnrolmentID, 3).subscribe(
          data => {
          },
          err => {
            debugger;
          },
          () => {
          })
      }
    }
  }
  onEditorPreparing(e) {
    if (e.parentType === "dataRow") {
      if (e.dataField === "IsChecked") {
        e.editorOptions.readOnly = e.row.data.IsDisabled;
        if ((e.row.data.Appear == "C") || (e.row.data.Appear === "R")) {
          e.editorOptions.readOnly = true;

        }
        if ((e.row.data.Appear == "R") || (e.row.data.Appear == "C")) {
          e.row.data.IsChecked = true;
          e.row.data.IsDisabled = true;
          e.row.data.GroupCompulsaryFlag1 = "Compulsory";
        }
        if (this.PreExamFormStudentData1.ApproveFlag == "Y") {
          e.editorOptions.readOnly = true;
        }
      };
    }
  }
  getdata() {
    /* if (this.StudentEnrolmentID  == null || this.StudentEnrolmentID  == undefined) {
      this.StudentEnrolmentID  = 0;
      return false;
    }
    this.EnrolmentFormService.GetEnrolmentUploadedFile( this.StudentEnrolmentID , this.configuration.StudentID) 
    .subscribe((data: PreExamFormStudent[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger
        if(this.dataSource.length>0){
         // this.PhysicalCertData=this.dataSource[0]; 
          if(this.dataSource[0].DocumentsList.length>0){
            this.DocumentsList=this.dataSource[0].DocumentsList;  
            if(this.dataSource[0].StudentEnrolmentID > 0){
              this.showButtons = true;    
            }            
          }         
        }
      });   */
  }
  onValueChangedBranch(e) {
    debugger;
    this.BranchID = e.value;
    if (this.BranchID == 0 || this.BranchID == null || this.BranchID == undefined) {
    } else {
      /* if(this.BranchID==422){
        this.prvmarkrequired=true;
      }else{
        this.prvmarkrequired=false;
      }  */
      this.getsubjects();
    }
  }
  getsubjects() {
    this.PersonalinformationService.GetSyllabusSubjectsForPortalForEnrolmentByBranch(this.PreExamFormStudentData1.CourseID, this.BranchID, this.configuration.CollegeID, this.configuration.StudentID, this.configuration.AcademicInstanceID, this.PreExamFormStudentData1.CoursePartID)
      .subscribe((data: EnrolmentSubject[]) => this.data = data,
        error => {
          alert(error);
        },
        () => {
          this.PreExamFormStudentData.PreStudentEnrolmentSubjectList = this.data;
          this.EnrolmentSubjectdata = this.PreExamFormStudentData.PreStudentEnrolmentSubjectList;
          this.PreExamFormStudentData.PreStudentEnrolmentSubjectList = [];
          for (var i = 0; i < this.EnrolmentSubjectdata.length; i++) {
            if (this.EnrolmentSubjectdata[i].GroupOrSubjectFlag == "G" && this.EnrolmentSubjectdata[i].GroupCompulsaryFlag == "Y") {
              this.MainSyllabusGroupID = this.EnrolmentSubjectdata[i].SyllabusGroupID;
              this.GroupMaxItemMain = this.EnrolmentSubjectdata[i].GroupMaxItem;
              this.GroupMinimumItemMain = this.EnrolmentSubjectdata[i].GroupMinimumItem;
            } else {
              var obj = {};
              obj = this.EnrolmentSubjectdata[i];
              this.PreExamFormStudentData.PreStudentEnrolmentSubjectList.push(obj);
            }
          }
          this.checkCompulsoryOrOptionalSubject();
          // this.getdata();
        });
  }
  ngOnInit() {
    this.LanguageLabel = this.configuration.LanguageLabel[0];
    if (this.configuration.StudentID == 0 || this.configuration.StudentID == undefined || this.configuration.StudentID == null) {
      this.helperService.showWarningMessage("Enrolment Form Not generated");
      this.router.navigate(['/dashboard']);
    }
    if (this.configuration.ExternalFlag == "N" || this.configuration.ExternalFlag == undefined || this.configuration.ExternalFlag == null) {
    } else {
      this.helperService.showWarningMessage("You are not allowed for that form.");
      this.router.navigate(['/dashboard']);
    }
    this.AdmissionService.GetProfileLockStatusForAdmissionForm(this.configuration.StudentID) //6123          
      .subscribe((data: UsertDetailsStatus[]) => this.dataSource = data,
        error => {
          alert(error);
        },
        () => {
          /* if(this.dataSource[0].ProfileLockStatusFlag =="N"){
            this.helperService.showWarningMessage("Your Profile is not locked. Please lock the profile");
            this.popupVisible3 = false; 
            this.router.navigate(['/dashboard']);
          }
          else
          { */



          this.EnrolmentFormService.GetEligibleCourseForEnrolment(this.configuration.StudentID, this.configuration.ExamInstanceID, this.configuration.AcademicInstanceID)
            .subscribe((data: PreExamFormStudent) => this.PreExamFormStudentData = data,
              error => {
                alert(error);
              },
              () => {
                if (this.PreExamFormStudentData.length == 0) {
                  this.helperService.showWarningMessage("Data Not Found");
                  this.router.navigate(['/dashboard']);
                }
                if (this.PreExamFormStudentData.length > 0) {
                  this.PreExamFormStudentData = this.PreExamFormStudentData[0];
                  this.EnrolmentSubjectdata = this.PreExamFormStudentData.PreStudentEnrolmentSubjectList;
                  this.PreExamFormStudentData.PreStudentEnrolmentSubjectList = [];
                  for (var i = 0; i < this.EnrolmentSubjectdata.length; i++) {
                    if (this.EnrolmentSubjectdata[i].GroupOrSubjectFlag == "G" && this.EnrolmentSubjectdata[i].GroupCompulsaryFlag == "Y") {
                      this.MainSyllabusGroupID = this.EnrolmentSubjectdata[i].SyllabusGroupID;
                      this.GroupMaxItemMain = this.EnrolmentSubjectdata[i].GroupMaxItem;
                      this.GroupMinimumItemMain = this.EnrolmentSubjectdata[i].GroupMinimumItem;
                    } else {
                      var obj = {};
                      obj = this.EnrolmentSubjectdata[i];
                      this.PreExamFormStudentData.PreStudentEnrolmentSubjectList.push(obj);
                    }
                  }
                  debugger;
                  this.BranchID = 0;
                  this.CourseselectionService.GetScheduleCheckForDirectAdmission(this.configuration.CollegeID, this.configuration.AcademicInstanceID, this.PreExamFormStudentData.CourseID, this.PreExamFormStudentData.CoursePartID, this.PreExamFormStudentData.BranchID, this.PreExamFormStudentData.StudentType)
                    .subscribe((data: ScheuldeData[]) => this.ScheduleList = data,
                      /*  this.EnrolmentFormService.GetCheckScheduleAndGetFeesForEnrollment(this.PreExamFormStudentData.CoursePartID,this.configuration.AcademicInstanceID,this.PreExamFormStudentData.BranchID,"R")
                          .subscribe((data:PreExamFormStudent) => this.ScheduleList = data, */
                      error => {
                        alert(error);
                      },
                      () => {
                        debugger;
                        if (this.ScheduleList.length == 0) {
                          this.helperService.showWarningMessage("Enrolment Form Schedule not present");
                          this.SaveClick = false;
                          this.PreExamFormStudentData.PreStudentEnrolmentSubjectList = [];
                          return;
                        }
                        else {
                          this.PreExamFormStudentData1 = this.PreExamFormStudentData;
                          if (this.PreExamFormStudentData1.CoursePartID == 4843) {
                            //this.prvmarkrequired = true;

                            this.prvmarkrequired = false;   //  Suggeted by Zapke Sir , ON 10-08-2023
                          }
                          else {
                            this.prvmarkrequired = false;
                          }
                          if (this.ScheduleList[0].ScheduleFlag == "N") {
                            this.helperService.showWarningMessage("Enrolment Form Schedule not present");
                            this.Savedisabled = true;
                            this.PreExamFormStudentData.PreStudentEnrolmentSubjectList = [];
                            return;
                          }
                          else {
                            this.PreExamFormStudentData.StudentTypestr = "Regular";
                            if (this.PreExamFormStudentData.StudentType == "R") {
                              this.PreExamFormStudentData.StudentTypestr = "Regular";
                            }
                            else if (this.PreExamFormStudentData.StudentType == "D") {
                              this.PreExamFormStudentData.StudentTypestr = "Distance";
                            }
                            this.PreExamFormStudentData1 = this.PreExamFormStudentData;
                            this.EnrolementBranchSelectionList = this.PreExamFormStudentData.EnrolementBranchSelectionList;
                            if (this.EnrolementBranchSelectionList.length > 0) {
                              this.branchislection = true;
                            } else {
                              this.branchislection = false;
                              this.checkCompulsoryOrOptionalSubject();
                            }

                            /*  this.EnrolmentFormService.GetScheduleFeesCheckForEnrolment(this.PreExamFormStudentData.CollegeID,this.configuration.AcademicInstanceID,this.PreExamFormStudentData.CourseID,this.PreExamFormStudentData.CoursePartID,this.PreExamFormStudentData.BranchID,this.PreExamFormStudentData2[0].EnrolmentScheduleID)
                             .subscribe((data:PreExamFormStudent) => this.PreExamFormStudentData3 = data,
                             error => {
                             alert(error);
                                 },
                                   () => {
                                           this.PreExamFormStudentData3=this.PreExamFormStudentData3[0];
                                           this.PreExamFormStudentData1=this.PreExamFormStudentData;

                                  
                                   }); */
                            this.EnrolmentFormService.GetStudentEnrollmentListForPortal(this.configuration.StudentID, this.PreExamFormStudentData.CoursePartID, this.configuration.AcademicInstanceID)
                              .subscribe((data: PreExamFormStudent) => this.StudentEnrollmentList = data,
                                error => {
                                  alert(error);
                                },
                                () => {
                                  if (this.StudentEnrollmentList.length > 0) {
                                    debugger
                                    this.StudentEnrollmentList = this.StudentEnrollmentList[0];
                                    this.PreExamFormStudentData1.StudentEnrolmentID = this.StudentEnrollmentList.StudentEnrolmentID;
                                    this.PreExamFormStudentData1.ApproveFlag = this.StudentEnrollmentList.ApproveFlag;
                                    this.PreExamFormStudentData1.BranchID = this.StudentEnrollmentList.BranchID;
                                    this.PreExamFormStudentData1.PrevExamMarksSheet = this.StudentEnrollmentList.PrevExamMarksSheet
                                    this.PreExamFormStudentData1.PrevExamMarksSheet2 = this.StudentEnrollmentList.PrevExamMarksSheet2
                                    this.PreExamFormStudentData1.PrevAdmReceipt = this.StudentEnrollmentList.PrevAdmReceipt

                                    if (this.StudentEnrollmentList.ApproveFlag == 'Y') {
                                      this.showButtons = false;
                                    }
                                    else {
                                      this.showButtons = true;
                                    }
                                    debugger;
                                    if (this.PreExamFormStudentData1.BranchID > 0) {
                                      this.BranchID = this.PreExamFormStudentData1.BranchID;
                                      this.branchdisable = true;

                                      //do not remove -  CoursePartID (B.Sc.(CBCS) PART III SEM V) set temp. hard coded for previous marks(as per discuss wih Anand sir) 
// SUGGESTED BY ZAPKE SIR ON 10-08-2023  START 
                                      // if (this.PreExamFormStudentData1.CoursePartID == 4843) {
                                      //   this.prvmarkrequired = true;

                                      //   this.PreExamFormStudentData1.PrevExam1Obtain = this.StudentEnrollmentList.PrevExam1Obtain;
                                      //   this.PreExamFormStudentData1.PrevExam1OutOff = this.StudentEnrollmentList.PrevExam1OutOff;
                                      //   this.PreExamFormStudentData1.PrevExam2Obtain = this.StudentEnrollmentList.PrevExam2Obtain;
                                      //   this.PreExamFormStudentData1.PrevExam2OutOff = this.StudentEnrollmentList.PrevExam2OutOff;
                                      //   this.PreExamFormStudentData1.PrevExam1SpecObtain = this.StudentEnrollmentList.PrevExam1SpecObtain;
                                      //   this.PreExamFormStudentData1.PrevExam1SpecOutOff = this.StudentEnrollmentList.PrevExam1SpecOutOff;
                                      //   this.PreExamFormStudentData1.PrevExam2SpecObtain = this.StudentEnrollmentList.PrevExam2SpecObtain;
                                      //   this.PreExamFormStudentData1.PrevExam2SpecOutOff = this.StudentEnrollmentList.PrevExam2SpecOutOff;
                                      //   ;

                                      // }
                                      // else {
                                      //   this.prvmarkrequired = false;
                                      // }
// SUGGESTED BY ZAPKE SIR ON 10-08-2023  END 
                                      this.getsubjects();
                                    }
                                    if (this.PreExamFormStudentData1.ApproveFlag == "Y") {
                                      this.ISApprove = true;
                                      this.Savedisabled = true;
                                      /* this.EnrolmentFormService.GetExamFormPrint(this.PreExamFormStudentData1.ExamInstanceID,this.PreExamFormStudentData.StudentExamID,this.configuration.StudentID)
                                      .subscribe((data:PreExamFormStudent) => this.ExamFormPrintData = data,
                                          error => {
                                          alert(error);
                                              },
                                      () => {
                                        this.ExamFormPrint=this.ExamFormPrintData.Message;
                                        this.printdis=false;
                                      }); */
                                      this.helperService.showWarningMessage("Enrolment Form is Approved so you cannot edit it");
                                    }
                                    else {
                                      this.ISApprove = false;
                                      this.Savedisabled = false;
                                    }
                                  }
                                  else {
                                    this.PreExamFormStudentData1.StudentEnrolmentID = 0;
                                  }

                                  if (this.PreExamFormStudentData1.OnLinePaymentConfirmFlag == "Y") {
                                    this.paymentdis = true;
                                    this.printrecdis = false;
                                  }
                                });

                          }
                        }
                      });
                }

              });
          //}
        });
  }
  onPaymentchange(e) {
    if (e.value == "Receipt") {
      this.PreExamFormStudentData1.PaymentType = "R";
      this.paymentdis = true;
      this.isDD = false;
    }
    if (e.value == "DD") {
      this.PreExamFormStudentData1.PaymentType = "D";
      this.paymentdis = true;
      this.isDD = false;
    }
    if (e.value == "Online") {
      this.PreExamFormStudentData1.PaymentType = "O";
      if (this.SaveClick == true) {
        this.paymentdis = false;
      }
      this.isDD = true;

    }
  }
  cancelClick() {
    this.router.navigate(['/dashboard']);
  }

  GetPaymentTrxNo() {
    ;
    this.PreExamFormStudentData1.PaymentType = "O";
    this.PreExamFormStudentData1.PurposeCode = this.configuration.PurposeCodeEnrolment;
    if (this.PreExamFormStudentData1.PaymentType == "O") {
      this.PreExamFormStudentData1.payModeID = 1;
    } else {
      this.PreExamFormStudentData1.payModeID = 0;
    }


    this.PreExamFormStudentData1.ExamInstanceID = this.configuration.ExamInstanceID;
    if (this.PreExamFormStudentData1.OnLinePaymentConfirmFlag == "Y") {
      this.cetService.GetPrintRecieptCET(this.PreExamFormStudentData1.StudentID, this.configuration.AcademicInstanceID, this.PreExamFormStudentData1.CourseID)
        .subscribe((data: CETadmission[]) => this.dataSource = data[0],
          error => {

            alert(error);
          },
          () => {
          });
    } else if (this.PreExamFormStudentData1.PaymentType == "O") {
      this.paymentdis = true;
      this.cetService.getPaymentTrxNo(this.PreExamFormStudentData1.StudentID, this.PreExamFormStudentData1.CourseID, this.PreExamFormStudentData1.CoursePartID, this.PreExamFormStudentData1.BranchID, this.configuration.AcademicInstanceID, this.configuration.ExamInstanceID, this.PreExamFormStudentData1.PurposeCode, this.PreExamFormStudentData1.TotalFeesAmount, 0, this.PreExamFormStudentData1.CollegeID)
        .subscribe((data: CETadmission[]) => this.dataSource = data,
          error => {
            alert(error);
          },
          () => {
            ;
            if (this.dataSource[0].merchantTxnNo != undefined || this.dataSource[0].merchantTxnNo != null) {
              this.PreExamFormStudentData1.customerName = this.dataSource[0].customerName;
              this.PreExamFormStudentData1.customerEmailId = this.dataSource[0].customerEmailId;
              this.PreExamFormStudentData1.customerMobileNo = this.dataSource[0].customerMobileNo;
              this.PreExamFormStudentData1.customerID = this.dataSource[0].OnlinePaymentID;
              this.PreExamFormStudentData1.merchantTxnNo = this.dataSource[0].merchantTxnNo;


              this.openWindowWithPostRequest();
            }
          });
    }
  }
  openWindowWithPostRequest() {
    ;
    var winName = 'MyWindow';
    var winURL = this.configuration.PaymentAPIURL;
    var windowoption = 'resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';

    var params = {
      'StudentID': this.configuration.StudentID, 'CourseID': this.PreExamFormStudentData1.CourseID,
      'BranchID': this.PreExamFormStudentData1.BranchID, 'AcadamicInstanceID': this.configuration.AcademicInstanceID,
      'PurposeCode': this.PreExamFormStudentData1.PurposeCode, 'FeesAmount': this.PreExamFormStudentData1.TotalFeesAmount,
      'merchantTxnNo': this.PreExamFormStudentData1.merchantTxnNo, 'customerName': this.PreExamFormStudentData1.customerName,
      'customerEmailId': this.PreExamFormStudentData1.customerEmailId, 'customerMobileNo': this.PreExamFormStudentData1.customerMobileNo,
      'customerID': this.PreExamFormStudentData1.customerID,
    };
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", winURL);
    form.setAttribute("target", winName);
    for (var i in params) {
      if (params.hasOwnProperty(i)) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
      }
    }
    document.body.appendChild(form);
    window.open('', winName, windowoption);
    form.target = winName;
    form.submit();
    document.body.removeChild(form);
    this.onSubmit();
  }

  timeLeft: number = 50;
  interval;

  onSubmit() {
    this.paymentmsg = "Your Payment Transaction in Process please wait...";
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;

        this.cetService.GetPaymentTranDetails(this.PreExamFormStudentData1.merchantTxnNo)
          .subscribe((data: CETadmission[]) => this.paysource = data,
            error => {
              alert(error);
            },
            () => {

              if (this.paysource.length == 0) {
                this.paymentdis = false;
                this.isExpired = true;

                return;
              }
              if (this.paysource[0].responseCode != undefined || this.paysource[0].responseCode != null) {


                if (this.paysource[0].OnlinePaymentConfirmFlag == "Y") {

                  this.EnrolmentFormService.GetUpdatePaymentStatusForEnrolmentForm(this.PreExamFormStudentData1.StudentID, this.PreExamFormStudentData1.merchantTxnNo, this.configuration.ExamInstanceID, this.PreExamFormStudentData1.CourseID, this.PreExamFormStudentData1.CoursePartID, this.PreExamFormStudentData1.BranchID, this.PreExamFormStudentData1.CollegeID)
                    .subscribe((data: PreExamFormStudent[]) => this.dataSource = data,
                      error => {
                        alert(error);
                      },
                      () => {
                        this.PreExamFormStudentData1.TotalFeesAmount = this.paysource[0].amount;
                        this.paymentdis = true;
                        this.helperService.showSuccessMessage("Your Payment Transaction is successful, your Transcation Number is " + this.paysource[0].merchantTxnNo);
                        this.printrecdis = false;
                      });

                }
                else {
                  this.PreExamFormStudentData1.TotalFeesAmount = this.paysource[0].amount;
                  this.paymentdis = false;
                  this.isExpired = true;
                  this.helperService.showWarningMessage("Your Payment Transaction is failure, your Transcation Number is " + this.paysource[0].merchantTxnNo + " try again...");
                }
                this.pauseTimer();
              }
              else {
                this.paymentmsg = "Your Payment Transaction in Process...";
              }

            });


      } else {
        this.pauseTimer();
        this.paymentmsg = "Transaction is time out please try again...";
      }
    }, 10000)
  }

  viewPdfDocument(data, flag) {
    debugger
    if (flag == 1) {
      if (this.PreExamFormStudentData1.PrevExamMarksSheet.length > 0) {
        this.documentId = flag;
        this.urlDoc = this.PreExamFormStudentData1.PrevExamMarksSheet;
        this.openWindow();
      }
    }
    else if (flag == 2) {
      if (this.PreExamFormStudentData1.PrevExamMarksSheet.length > 0) {
        this.documentId = flag;
        this.urlDoc = this.PreExamFormStudentData1.PrevExamMarksSheet2;
        this.openWindow();
      }
    }
    else if (flag == 3) {
      if (this.PreExamFormStudentData1.PrevExamMarksSheet.length > 0) {
        this.documentId = flag;// this.PreExamFormStudentData1.StudentEnrolmentID
        this.urlDoc = this.PreExamFormStudentData1.PrevAdmReceipt;
        this.openWindow();
      }
    }
  }

  onCloseButton() {
    this.popupVisible3 = false;
  }
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  popupHiding(e) {
    this.errorMessage = [];
  };

  pauseTimer() {
    clearInterval(this.interval);
  }

  removeDocument(flag) {
    debugger
    //this.RemoveFileData =data;
    this.popupVisible3 = true;
    this.flag = flag;
  }

  RemoveFileconfirmOK() {
    debugger
    var deleteDocument = {
      "StudentEnrolmentID": this.PreExamFormStudentData1.StudentEnrolmentID,
      "UpdatedLoginID": this.configuration.UpdatedLoginID,
      "StudentID": this.configuration.StudentID,
      "CertId": this.flag
    }

    this.EnrolmentFormService.deleteUploadedDocument(deleteDocument)
      .subscribe((data: PreExamFormStudent) => {
        debugger
        this.popupVisible3 = false;
        this.helperService.showSuccessMessage("File Deleted Successfully.");
        if (this.flag == 1) {
          this.PreExamFormStudentData1.PrevExamMarksSheet = "";
        }
        else if (this.flag == 2) {
          this.PreExamFormStudentData1.PrevExamMarksSheet2 = "";
        }
        else if (this.flag == 3) {
          this.PreExamFormStudentData1.PrevAdmReceipt = "";
        }
      },
        error => {
          this.popupVisible3 = false;
          alert(error);
        },
        () => {

        });

  }
}












